import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import DetailedStatistics from '../../components/Stats/DetailedStatistics';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['pushNotifications']}`;

const PushNotificationsStatisticsPage = () => {
  const fetch = useFetch();

  const [pushNotification, setTextMessage] = useState();
  const [error, setError] = useState();
  const { accountId, domainId, pushNotificationId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pushNotifications/${pushNotificationId}`)
      .then(({ pushNotification }) => setTextMessage(pushNotification))
      .catch(setError);
  }, [accountId, domainId, pushNotificationId, fetch]);

  return (
    <>
      <Metadata title={`${page} | ${pushNotification?.name || 'Unnamed push notification'}`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/push`}>{page}</Anchor>
        <Text>{pushNotification?.name || 'Unnamed push notification'}</Text>
      </Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <DetailedStatistics name={pushNotification?.name} scope="pushNotifications" id={pushNotificationId} />
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default PushNotificationsStatisticsPage;
